export const mutations = {
  onGet (state, payload) {
    payload.event.context.unitTypes = payload.response.data.data.data
    if (payload.event.context.options) {
      payload.event.context.options.itemsPerPage = parseInt(payload.response.data.data.per_page)
      payload.event.context.options.page = payload.response.data.data.current_page
      payload.event.context.options.total = payload.response.data.data.total
    }
    payload.event.context.loadingTable = false
  },
  onGetAll (state, payload) {
    payload.event.context.unitTypes = payload.response.data.data.data
    payload.event.context.loadingTable = false
  },
  onGetById (state, payload) {
    payload.event.context.unitType = payload.response.data.data
    payload.event.context.loading = false
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.get()
  }
}
